import { Box, Paper, Stack, Tooltip, Typography } from "@mui/material";
import { defaultData, formatFixedOneNotation, formatIndianNumber, tooltipAttr } from "components/Reports/DashboardComponents/Home/StoreListCards/data";
import React, { useEffect, useRef, useState } from "react";
import StoreSkeleton from "./StoreSkeleton";
import { calculateGrowth } from "components/Reports/data";


export default function StoreList({name="", data, loading, width=400, height=600}) {


  const listStyle = {width: "350px", height: "45px", margin: "3px 0px", minWidth: 'maxContent', display:"flex", justifyContent:'center', alignItems:'center' }

  const tooltipDataShow = (tooltipData) =>{
    console.log("tooltipDataShow", tooltipData)
    return(
      tooltipAttr.map((d)=>{
        if (tooltipData[d.key]){
          const value = tooltipData[d.key]
          const show = d.key === "age" ? "Months" : ""
          const growth = d.key === "ty_amt" ? calculateGrowth(tooltipData?.ly_amt, tooltipData?.ty_amt) : ""
          const tooltipVal = formatFixedOneNotation(value, !isNaN(value) ? ["store_count", "age"].includes(d.key) ? "": "value" : "")
          const growthColor = growth >= 0 ? "green" : "red";
          console.log("AXbAbABKSDJBKabskA", show, growth, tooltipData[d.key], growthColor)
          return (
          <Stack display={"flex"} flexDirection={"row"}>
            <Typography sx={{ fontSize:"var(--font-size-tooltip)", marginRight: "2px"}}>{d.name}:</Typography>
            <Typography sx={{ fontSize:"var(--font-size-tooltip)"}}>{tooltipVal} {show} {growth && <span style={{color:growthColor}}>{`(${growth}%)`}</span>}</Typography>
          </Stack>
          )
        }
      })
    )
  }

  return (
    loading ? (
    <StoreSkeleton width={width} height={height} />
  ) : (
     <Box
     sx={{
      marginTop: '5px'
     }}
    >
      <Paper sx={listStyle} elevation={3} >
        <Typography fontSize={"var(--font-size-h2)"} fontWeight={600}>
                  {name}
        </Typography>

      </Paper>
      {
        data.map((store)=>(
          <Tooltip title={tooltipDataShow(store)} slotProps={{
              tooltip: {
                sx: {
                  backgroundColor: "var(--color-tooltip-background)",
                  color: "var(--color-tooltip)",
                  // border: "0.2px solid black",
                }
              }
            }} followCursor>
            <Paper sx={listStyle} elevation={2} >
              <Typography sx={{fontSize: "var(--font-size-body)"}}>
                {store.name}  
              </Typography>
            </Paper>
          </Tooltip>
        ))
      }
    </Box>
  ))
}
